import { createContext, FC, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface LoadingContextType {
	isLoading: boolean;
	setLoading: (isLoading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);

	const setLoading = useCallback((loading: boolean) => setIsLoading(loading), []);

	const value = useMemo(() => ({ isLoading, setLoading }), [isLoading, setLoading]);

	return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};

export const useLoading = (): LoadingContextType => {
	const context = useContext(LoadingContext);
	if (!context) {
		throw new Error('useLoading must be used within a LoadingProvider');
	}
	return context;
};
